import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { walletsAtom } from '@root/entities/wallet'
import { editWalletRequestAction } from '@root/features/wallet/edit-wallet'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { WalletId } from '@root/entities/wallet'

export const toggleFavoriteWalletAction = action(
  async (ctx, walletId: WalletId) => {
    const wallets = ctx.get(walletsAtom)
    const wallet = wallets.find((wlt) => wlt.id === walletId)
    if (!wallet) {
      return
    }

    const result = await ctx.schedule(() =>
      editWalletRequestAction(ctx, {
        walletId: walletId,
        parameters: {
          favorite: !ctx.get(wallet.favorite),
        },
      }),
    )

    if (Result.isFailure(result)) {
      showSnackbarAction(ctx, {
        text: 'Unable to update wallet',
        intent: 'error',
      })
    }
  },
  'toggleFavoriteWalletAction',
)
